import { RawUserPersonalInfoModel } from "../user_personal_info_model.js";

class RawAdminUserPersonalInfoModel extends RawUserPersonalInfoModel {

  formFieldsWhitelist(item=undefined) {
    if (item && item.salutation == 'firma')
      return ["salutation", "title", "firstName", "lastName", "companyName"];
    return ["salutation", "title", "firstName", "lastName"];
  }

}
const AdminUserPersonalInfoModel = new RawAdminUserPersonalInfoModel();

export { RawAdminUserPersonalInfoModel, AdminUserPersonalInfoModel }
